import { ISco } from 'src/app/models/sco.interface';

export interface IScoState {
    sco: ISco[];
}

export const initialScoState: IScoState = {
    sco: null
};
